<script>
    import { onMount } from 'svelte';
    import { fetchTwoFaChallenge, sendTwoFaChallenge } from '/public/services/users/users';

    export let currentRoute;

    let hash = currentRoute.namedParams.hash;
    let loading = true;
    let name = null;
    let otp = null;

    function challengeOTP(e) {
        e.preventDefault();
        sendTwoFaChallenge(hash,otp).then(res => {
            if (res.success) {
                window.location = res.data.url;
            }
        });
    }

    onMount(() => {
        fetchTwoFaChallenge(hash).then(res => {
            if (res.success) {
                name = res.data.name;
                loading = false;
            } else {
                window.location = '/';
            }
        });
    });
</script>

<h3>
    <span class="fas fa-shield-alt"></span> Two factor authentication challenge
</h3>
{#if loading === true}
    <div class="text-center">
        <h4>
            <span class="ajax-ball-loader"></span> Checking your authentication permissions....
        </h4>
    </div>
{:else}
    <div class="row justify-content-center mt-3">
        <div class="col-sm-12 col-md-6">
            <div class="card">
                <div class="card-header">
                    <span class="fas fa-user-lock"></span> OTP Challenge
                </div>
                <div class="card-body">
                    <p>
                        We need to confirm your 2FA setup in your authenticator app<br/>
                        Enter the OTP code from your authenticator app in the form below.<br/>
                    </p>
                    <form class="form" on:submit={challengeOTP}>
                        <div class="row mb-3">
                            <label class="col-sm-2 col-form-label" for="otp_code">
                                OTP
                            </label>
                            <div class="col-sm-8">
                                <input type="text" id="otp_code" class="form-control" required bind:value={otp} placeholder="Enter your OTP code"/>
                            </div>
                            <div class="col-sm-2">
                                <button type="submit" class="btn btn-primary">
                                    <span class="fas fa-save"></span>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
{/if}
